
export const generateFilterLabel = (idKey, key, item) => {
	let label = item[key] ?? item.serviceProviderEmail
	if (idKey === 'dataOwnerOrgId') {
		label = item[key] ?? item.dataOwnerEmail
	}
	if (idKey === 'senderOrgId') {
		label = item[key] ?? item.senderEmail
	} else if (idKey === 'receiverOrgId') {
		label = item[key] ?? item.receiverEmail
	} else if (idKey === 'serviceProviderOrgId' && !item[idKey] && !item.serviceProviderEmail) {
		label = 'No Solution Provider'
	}

	return label
}

export const generateFilterId = (record, compareKey, mapper) => {
	if (compareKey.toLowerCase() === 'status') {
		return record[compareKey]
	}
	return record[compareKey] ? compareKey + record[compareKey] : record[mapper[compareKey]] ?? record[compareKey]

}

export const extractUniqueValuesUsingMap = (data, key, idKey, orgId, categoryMap) => {
	const uniqueValuesMap = new Map();
	const keyMap = {
		senderOrgId: 'senderEmail',
		receiverOrgId: 'receiverEmail',
		serviceProviderOrgId: 'serviceProviderEmail',
		dataOwnerOrgId: "dataOwnerEmail",
		status: 'statusLabel'
	}
	data?.forEach(item => {
		const dynamicKeyName = keyMap[key]
		const struc = {
			orgId: item[idKey] ?? [dynamicKeyName],
			label: generateFilterLabel(idKey, key, item),
			record: item
		};
		uniqueValuesMap.set(struc.label, struc);
	});
	return Array.from(uniqueValuesMap.values()).map((item) => {
		const filterId = generateFilterId(item.record, idKey, keyMap) ?? 'no_service_provider';
		const data = {
			id: filterId,
			orgId: item.orgId,
			label: orgId === item.orgId ? 'Myself' : item.label,
			category: categoryMap[key] || key
		}
		return (data)
	});

}

export const filterDropdownHandler = (data, filterOptions) => {
	return data.filter((item) => {
		const categoryMatch = {};

		filterOptions?.forEach((filter) => {
			switch (filter.category) {
				case 'Data Element Name':
					categoryMatch['Data Element Name'] = categoryMatch['Data Element Name'] || filter.orgId === item.dataElementId;
					break;
				case 'From':
					categoryMatch['From'] =
						categoryMatch['From'] ||
						(item.senderOrgName
							? filter.orgId === item.senderOrgId
							: filter.label === item.senderEmail);
					break;
				case 'Via':
					categoryMatch['Via'] =
						categoryMatch['Via'] ||
						(item.serviceProviderOrgId
							? filter.orgId === item.serviceProviderOrgId
							: item.serviceProviderEmail
								? filter.label === item.serviceProviderEmail
								: filter.label === 'No Solution Provider');
					break;
				case 'To':
					categoryMatch['To'] =
						categoryMatch['To'] ||
						(item.receiverOrgName
							? filter.orgId === item.receiverOrgId
							: filter.label === item.receiverEmail);
					break;
				case 'Status':
					categoryMatch['Status'] = categoryMatch['Status'] || filter.id === item.status;
					break;
				default:
					break;
			}
		});

		return Object.values(categoryMatch).every(Boolean);
	});
}

export const searchRecords = (item, fields, searchValue) => {
	const lowerSearchValue = searchValue?.toLowerCase();
	return fields.some((field) => item[field]?.toLowerCase().includes(lowerSearchValue));
}


export const updateFilterByParams = (pageDataArr, filterQueryParams, compareKeyName, labelKeyName, categoryName, pageName) => {
	const localMap = {
		senderOrgId: 'senderEmail',
		receiverOrgId: 'receiverEmail',
		serviceProviderOrgId: 'serviceProviderEmail',
		dataOwnerOrgId: "dataOwnerEmail",
		status: 'statusLabel'
	}
	const finalFilterArr = []
	const filterQueryParamArr = filterQueryParams.split(',');
	filterQueryParamArr.forEach((paramId) => {
		const filteredRecord = pageDataArr.find(item => item[compareKeyName] === paramId || item[localMap[compareKeyName]] === paramId)
		if (filteredRecord) {
			finalFilterArr.push({
				id: generateFilterId(filteredRecord, compareKeyName, localMap) ?? 'no_service_provider',
				label: filteredRecord[labelKeyName] ? filteredRecord[labelKeyName] : filteredRecord[localMap[compareKeyName]],
				category: categoryName,
				orgId: paramId
			})
		}
	})
	return finalFilterArr


}

export const isLastCombination = (data, record) => {
	const { senderOrgId, dataElementId, dataExchangeRelationshipStatus, senderEmail, receiverOrgId, receiverEmail } = record;

	if (dataExchangeRelationshipStatus !== 'APPROVED') return false;

	const keyCombination = {};
	if (senderOrgId) keyCombination.senderOrgId = senderOrgId;
	if (senderEmail) keyCombination.senderEmail = senderEmail;
	if (receiverOrgId) keyCombination.receiverOrgId = receiverOrgId;
	if (receiverEmail) keyCombination.receiverEmail = receiverEmail;
	keyCombination.dataElementId = dataElementId;

	// Find matching records based on keyCombination
	const matchingRecords = data.filter(item =>
		Object.keys(keyCombination).every(key => item[key] === keyCombination[key])
	);

	// If no matching records exist, return false
	if (matchingRecords.length === 0) return false;

	// Further filter records based on allowed status
	const allowedStatus = ['APPROVED', 'PENDING'];
	const possibleRecordsArr = matchingRecords.filter(item =>
		item.dataExchangeRelationshipStatus === "APPROVED" &&
		allowedStatus.includes(item.serviceProviderRelationshipStatus)
	);

	return possibleRecordsArr.length === 1;
};


export const generateQueryString = (filters) => {
	return Object.keys(filters)
		.map(category =>
			filters[category].length > 0 ? `${category}=${filters[category].join(',')}` : null
		)
		.filter(Boolean)
		.join('&');
};

export const getCorrectLabel = (elem) => {
	return Array.isArray(elem.orgId) ? elem.label : elem.orgId
}



export const categorizeFilters = (param, filterSchema) => {
	const filters = Object.keys(filterSchema).reduce((acc, key) => {
		acc[key] = [];
		return acc;
	}, {});

	param.forEach(item => {
		const key = Object.keys(filterSchema).find(k => filterSchema[k].includes(item.category));

		if (key) {
			let value;
			if (item.category === 'Status') {
				value = item?.label?.toUpperCase() === 'PENDING YOUR APPROVAL' ? 'PENDING_YOUR_APPROVAL' : item.label.toUpperCase();
			} else {
				value = getCorrectLabel(item);
			}
			filters[key].push(value);
		}
	});

	return filters;
};

export const  groupByCombination =(records)  =>{
	const grouped = new Map();
	if(records.length === 0) return grouped;

	records.forEach((recordItem) => {
		const {dataElementId, initiater, senderOrgId, senderEmail, receiverOrgId, receiverEmail } = recordItem;
		let sender, receiver;
		const isSender = initiater === 'SENDER';
		sender = isSender ? (senderOrgId || senderEmail) : (receiverOrgId || receiverEmail);
		receiver = isSender ? (receiverOrgId || receiverEmail) : (senderOrgId || senderEmail);

		const key = `${dataElementId}_${initiater}_${sender}_${receiver}`;

		if (!grouped.has(key)) {
			grouped.set(key, []);
		}

		grouped.get(key).push(recordItem);
	});

	return grouped;
}

export const isLastSpForAnyCombination =(groupedMap, spId) =>{
	let isLast = false;
	for (const [, value] of groupedMap.entries()) {
		if(value.length ===1 && value[0].serviceProviderOrgId === spId){
			isLast = true;
			break;
		}
	}
	return isLast;
}

export const filterCommonSpRecords = (records, data, orgId) => {
	const dynamicFilterKey = data.flow === 'SEND' ? 'senderOrgId' : 'receiverOrgId';
	const statusEnumArr = ["APPROVED", "PENDING"];
	return records.filter(record =>
		record.dataElementId === data.dataElementId &&
		record[dynamicFilterKey] === orgId &&
		statusEnumArr.includes(record.dataExchangeRelationshipStatus) &&
		statusEnumArr.includes(record.serviceProviderRelationshipStatus)
	);
}

export const statusIdMapper = {
	APPROVED: 2,
	ACTIVE: 2,
	INACTIVE: 3,
	REVOKED: 4,
	PENDING: 5,
	'PENDING_YOUR_APPROVAL': 6,
	"PENDING YOUR APPROVAL": 6,
	REJECTED: 7
}
